const HOME_DATA_KEY_PREFIX = 'home-';

export function clearHomeCache() {
  const isHomeDataKey = key => key.startsWith(HOME_DATA_KEY_PREFIX);

  clearNuxtData(isHomeDataKey);
  clearNuxtState(isHomeDataKey);
}
